// tslint:disable:curly
import { DbRecordService } from './db-record.service'
import { Project } from './project'
import { Tag } from './tag';


export class DbRecord {
  id: string;
  abstract: string;
  authors: string[] = [];
  doi: string;
  endPage: string;
  issn: string;
  issue: string;
  lang: string;
  recordId: string;
  source: string;
  startPage: string;
  title: string;
  volume: string;
  year: number;
  linkCode: string;
  _position: number;
  _criterionTitle: string;
  _criterionAbstract: string;

  constructor(
    private dbrs: DbRecordService,
    public project: Project,
    params: Object
  ) {
    Object.keys(params).forEach(k => this[k] = params[k]);
    this.id = this.recordId;
    this.linkCode = project.linkCodes[this.id];
    this.dbrs.dbRecordsMap.get(this.project.id).set(this.id, this);
    this.dbrs.listsMap.get(this.project.id).push(this);
  }

  hasRatingCode(code) {
    return this.dbrs.hasRatingCode(this, code);
  }

  hasTags(tags: Set<Tag>) {
    let ls = [];
    tags.forEach((v) => ls.push(v));
    for (let t of ls) {
      if (!t.taggedItems.has(this.id))
        return false;
    }
    return true;
  }

  excludeTags(tags: Set<Tag>) {
    let ls = [];
    tags.forEach((v) => ls.push(v));
    for (let t of ls)
      if (t.taggedItems.has(this.id))
        return false;
    return true;
  }


  regexpHit(regexp: RegExp) {
    if (regexp.test(this.title))
      return true;
    if (regexp.test(this.abstract || ''))
      return true;
    return false;
  }

  yearHit(fromYear: number, toYear: number) {
    fromYear = fromYear || 0;
    toYear = toYear || 9999;
    return this.year >= fromYear && this.year <= toYear;
  }

  sortTuple(ls) {
    let tuple = [];
    ls.map((x) => {
      switch (x) {
        case 'dateAsc':
          tuple.push(this.year);
          break;
        case 'dateDesc':
          tuple.push(-1 * this.year);
          break;
        case 'source':
          tuple.push(this.source);
          break;
        default:
          let v = this.dbrs.getCriterion(x).run(this);
          tuple.push(v);
      }
    });
    return tuple;
  }

  get authorsHTML() {
    let ls = [];
    this.authors.forEach(x => ls.push(x));
    return ls.join('; ');
  }


  get scVolume() {
    let v = this.volume;
    if (!v)
      return '';
    if (!this.issue)
      v += ',';
    return v;
  }


  get scIssue() {
    if (!this.issue)
      return '';
    return `(${this.issue}),`;
  }

  get scStartPage() {
    let p = this.startPage;
    if (!p)
      return '.';
    if (!this.endPage)
      p += '.';
    return p;
  }

  get scEndPage() {
    if (!this.endPage)
      return '';
    return `-${this.endPage}.`;
  }


  get shortCitation() {
    let doi;
    if (this.doi)
      doi = ` [<a target='_blank' href='http://dx.doi.org/${this.doi}'>${this.doi}</a>]`;
    else
      doi = '';

    return `${this.source}, <span class='year'>${this.year}</span>, ${this.scVolume}${this.scIssue}
  ${this.scStartPage}${this.scEndPage}
  ${doi}`;
  }

  get fastRejectDisplay() {
    return `${this.title}, ${this.source}, <span class='year'>${this.year}</span>, ${this.scVolume}${this.scIssue}
    ${this.scStartPage}${this.scEndPage}`;
  }

  get search() {
    let searchLs = [];
    searchLs.push(`<a href="http://scholar.google.com/scholar?q=${encodeURIComponent(`"${this.title}"`)}" target="_blank">Scholar for title</a>`);
    if (this.doi)
      searchLs.push(`<a href="http://scholar.google.com/scholar?q=${encodeURIComponent(this.doi)}" target="_blank">Scholar for DOI</a>`);
    searchLs.push(`<a href="http://google.com/?q=${encodeURIComponent(`"${this.title}"`)}" target="_blank">Google for title</a>`);
    if (this.doi)
      searchLs.push(`<a href="http://google.com/?q=${encodeURIComponent(this.doi)}" target="_blank">Google for DOI</a>`);

    return searchLs.join(' | ');
  }

  criterionText(txt: string) {
    if (!txt)
      return '';
    return txt.toLowerCase().replace(/[^a-z0-9-]/g, ' ').replace('\s+', ' ').trim();
  }

  clearCriterionTextCache() {
    this._criterionTitle = null;
    this._criterionAbstract = null;
  }

  get criterionTitle() {
    if (!this._criterionTitle)
      this._criterionTitle = this.criterionText(this.title);
    return this._criterionTitle;
  }

  get criterionAbstract() {
    if (!this._criterionAbstract)
      this._criterionAbstract = this.criterionText(this.abstract);
    return this._criterionAbstract;
  }


  endnoteExportRow(tpl) {
    if (tpl[1] === null || tpl[1] === undefined)
      return null;
    let tag = tpl[0];
    let items = tpl[1];
    if (typeof items == 'string')
      items = [items];
    return items.map(x => `${tpl[0]}  - ${x.trim()}`).join('\n');
  }


  endnoteExport(selectedRTags) {
    let ls = [];
    let tags = [
      ["TY", "JOUR"],
      ["TI", this.title],
      ["T2", this.source],
      ["VL", this.volume],
      ["IS", this.issue],
      ["SP", this.startPage],
      ["EP", this.endPage],
      ["AU", this.authors],
      ["PY", this.year ? this.year.toString() : null],
      ["DO", this.doi],
      ["AB", this.abstract],
      ["UR", this.id],
    ];
    tags.forEach(tpl => {
      let txt = this.endnoteExportRow(tpl);
      if (txt)
        ls.push(txt);
    });
    let s = this.project.ratingSummary(this, 'abstract');
    let kwSet = new Set<string>();
    if (s) {
      s.forEach(x => {
        let tp;
        if (x[0] == 'accepted') {
          tp = "A";
        } else if (x[0] == 'rejected') {
          tp = 'R';
        }
        if (tp) {

          kwSet.add(`${tp}_all`);
          x[1].forEach(y =>
            kwSet.add(`${tp}_${y}`)
          );
        }

      });
    }
    let kwList = Array.from(kwSet);
    kwList.sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1);
    kwList.forEach(x => ls.push(this.endnoteExportRow(['KW', x])));
    let rtagList = [];
    selectedRTags.forEach(x => rtagList.push(this.project.rTagsTitlesMap.get(x)));
    rtagList.sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1);
    rtagList.forEach(x => ls.push(this.endnoteExportRow(['KW',
      `T_${x.replace(/ +/g, '_')}`])));
    ls.push(this.endnoteExportRow(["ER", ""]));
    return ls.join('\n');
  }

  jsonExport(selectedTags) {
    const abstractRatings = [];
    const fulltextRatings = [];

    const as = this.project.ratingSummary(this, 'abstract');
    if (as) {
      as.forEach((m, k) => {
        abstractRatings.push({ rater: k, rating: m[0], reasons: Array.from(m[1]) });
      });
    }

    const fs = this.project.ratingSummary(this, 'fulltext');
    if (fs) {
      fs.forEach((m, k) => {
        abstractRatings.push({ rater: k, rating: m[0], reasons: Array.from(m[1]) });
      });
    }

    const rtags = Array.from(selectedTags || []);

    const dct = {
      id: this.id,
      abstract: this.abstract,
      title: this.title,
      authors: this.authorsHTML,
      year: this.year,
      volume: this.volume,
      issue: this.issue,
      source: this.source,
      startPage: this.startPage,
      endPage: this.endPage,
      doi: this.doi,
      abstractRating: abstractRatings,
      fultextRating: fulltextRatings,
      rtags: rtags
    };
    return dct;
  }


  csvExportList(selectedRTags, isExpanded) {
    let ls = [];
    ls.push(this.title);
    ls.push(this.authorsHTML);
    ls.push(this.year);
    ls.push(this.source);
    ls.push(`${this.scVolume}${this.scIssue}${this.scStartPage}${this.scEndPage}`);
    ls.push(this.doi);
    let s = this.project.ratingSummary(this, 'abstract');
    let rejectedSet = new Set<string>();
    let rejectFields = Array(this.project.abstractRejectIds.length + 1).fill("");
    let acceptedSet = new Set<string>();
    let acceptFields = Array(this.project.abstractAcceptIds.length + 1).fill("");
    if (s)
      s.forEach(x => {
        if (x[0] == 'rejected') {
          rejectFields[0] = "X";
          x[1].forEach(y => rejectedSet.add(y));
        } else if (x[0] == 'accepted') {
          acceptFields[0] = "X";
          x[1].forEach(y => acceptedSet.add(y));
        }
      });

    for (let i = 0; i < this.project.abstractRejectIds.length; i++) {
      if (rejectedSet.has(this.project.abstractRejectIds[i]))
        rejectFields[i + 1] = "X";
    }
    rejectFields.forEach(x => ls.push(x));

    for (let i = 0; i < this.project.abstractAcceptIds.length; i++) {
      if (acceptedSet.has(this.project.abstractAcceptIds[i]))
        acceptFields[i + 1] = "X";
    }
    acceptFields.forEach(x => ls.push(x));

    let rtagFields;
    if (isExpanded) {
      rtagFields = [];
      this.project.rtags.forEach(tpl => {
        if (!selectedRTags) {
          console.log(this.recordId, this.title);
          return;
        }
        ls.push(selectedRTags.has(tpl[0]['id']) ? "X" : "");
        tpl[1].forEach(x => ls.push(selectedRTags.has(x['id']) ? "X" : ""));
      });
    } else {
      rtagFields = Array(this.project.rtags.length).fill("");
      if (selectedRTags) {
        this.project.rtags.forEach((tpl, i) => {
          if (selectedRTags.has(tpl[0]['id'])) {
            let tmp = [];
            tpl[1].forEach(x => {
              if (selectedRTags.has(x['id']))
                tmp.push(x['title']);
            });
            rtagFields[i] = `X (${tmp.join("; ")})`;
          }
        });
      }
      rtagFields.forEach(x => ls.push(x));
    }

    return ls;
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/db-record.ts